import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/bulk.literals.selectors';

@Injectable({
  providedIn: 'root',
})
export class BulkLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  newBulkOperation$ = this.storeSelect(selectors.getNewBulkOperation);
  header$ = this.storeSelect(selectors.getHeader);
  bulkHistory$ = this.storeSelect(selectors.getBulkHistory);
  configurationName$ = this.storeSelect(selectors.getConfigurationName);
  profileModel$ = this.storeSelect(selectors.getProfileModel);
  configurationDescription$ = this.storeSelect(selectors.getImportConfigurationDescription);
  supportedFile$ = this.storeSelect(selectors.getSupportedFile);
  integrationStatus$ = this.storeSelect(selectors.getIntegrationStatus);
  integrationsActive$ = this.storeSelect(selectors.getIntegrationsActive);
  bulkStatus$ = this.storeSelect(selectors.getBulkStatus);
  bulkImportDate$ = this.storeSelect(selectors.getBulkImportDate);
  bulkInProgress$ = this.storeSelect(selectors.getBulkInProgress);
  bulkAll$ = this.storeSelect(selectors.getBulkAll);
  totalLinesImport$ = this.storeSelect(selectors.getTotalLinesImport);
  importDate$ = this.storeSelect(selectors.getImportDate);
  config$ = this.storeSelect(selectors.getConfig);
  errorsFound$ = this.storeSelect(selectors.getErrorsFound);
  logId$ = this.storeSelect(selectors.getLogId);
  logDate$ = this.storeSelect(selectors.getLogDate);
  logMessage$ = this.storeSelect(selectors.getLogMessage);
  logDateChanged$ = this.storeSelect(selectors.getLogDateChanged);
  chooseProfileModel$ = this.storeSelect(selectors.getChooseProfileModel);
  mapFileData$ = this.storeSelect(selectors.getMapFileData);
  saveBulkConfiguration$ = this.storeSelect(selectors.getSaveBulkConfiguration);
  addNewConfigurationDescription$ = this.storeSelect(selectors.getAddNewConfigurationDescription);
  startNewBulkOperationQuestion$ = this.storeSelect(selectors.getStartNewBulkOperationQuestion);
  fileType$ = this.storeSelect(selectors.getFileType);
  fileName$ = this.storeSelect(selectors.getFileName);
  dataDelimiter$ = this.storeSelect(selectors.getDataDelimiter);
  firstLineContainsHeader$ = this.storeSelect(selectors.getFirstLineContainsHeader);
  chooseFile$ = this.storeSelect(selectors.getChooseFile);
  dragAndDropFile$ = this.storeSelect(selectors.getDragAndDropFile);
  or$ = this.storeSelect(selectors.getOR);
  dataMap$ = this.storeSelect(selectors.getDataMap);
  profileModelKey$ = this.storeSelect(selectors.getProfileModelKey);
  advancedMappingOptions$ = this.storeSelect(selectors.getAdvancedMappingOptions);
  chooseAnotherFile$ = this.storeSelect(selectors.getChooseAnotherFile);
  flowName$ = this.storeSelect(selectors.getFlowName);
  attributeMappingRules$ = this.storeSelect(selectors.getAttributeMappingRules);
  bulkConfiguration$ = this.storeSelect(selectors.getBulkConfiguration);
  bulkGroupName$ = this.storeSelect(selectors.getBulkGroupName);
  bulkDescription$ = this.storeSelect(selectors.getBulkDescription);
  bulkFilesFirstLine$ = this.storeSelect(selectors.getBulkFilesFirstLine);
  bulkFile$ = this.storeSelect(selectors.getBulkFile);
  fileNumberOfLines$ = this.storeSelect(selectors.getFileNumberOfLines);
  execute$ = this.storeSelect(selectors.getExecute);
  configurationSaved$ = this.storeSelect(selectors.getConfigurationSaved);
  keyNotMapped$ = this.storeSelect(selectors.getKeyNotMapped);
  userSure$ = this.storeSelect(selectors.getUserSure);
  deactivateConfigMessage$ = this.storeSelect(selectors.getDeactivateConfigMessage);
  notificationEmail$ = this.storeSelect(selectors.getNotificationEmail);

  // OBSERVABLE'S VALUES
  get configurationName() {
    return this.storeSnapshot(this.configurationName$);
  }

  get profileModel() {
    return this.storeSnapshot(this.profileModel$);
  }

  get configurationDescription() {
    return this.storeSnapshot(this.configurationDescription$);
  }

  get supportedFile() {
    return this.storeSnapshot(this.supportedFile$);
  }

  get integrationStatus() {
    return this.storeSnapshot(this.integrationStatus$);
  }

  get bulkInProgress() {
    return this.storeSnapshot(this.bulkInProgress$);
  }

  get bulkAll() {
    return this.storeSnapshot(this.bulkAll$);
  }

  get totalLinesImport() {
    return this.storeSnapshot(this.totalLinesImport$);
  }

  get importDate() {
    return this.storeSnapshot(this.importDate$);
  }

  get config() {
    return this.storeSnapshot(this.config$);
  }

  get bulkStatus() {
    return this.storeSnapshot(this.bulkStatus$);
  }

  get bulkImportDate() {
    return this.storeSnapshot(this.bulkImportDate$);
  }

  get logId() {
    return this.storeSnapshot(this.logId$);
  }

  get logDate() {
    return this.storeSnapshot(this.logDate$);
  }

  get logMessage() {
    return this.storeSnapshot(this.logMessage$);
  }

  get logDateChanged() {
    return this.storeSnapshot(this.logDateChanged$);
  }

  get configurationSaved() {
    return this.storeSnapshot(this.configurationSaved$);
  }

  get keyNotMapped() {
    return this.storeSnapshot(this.keyNotMapped$);
  }
}
